import api from '@/api';
import {
  GPStatus,
  GPStatusCreateRequest,
  GPStatusEditRequest,
  GPStatusListRequest,
  GPStatusListResponse,
  GPStatusPositionEditRequest,
} from './status.types';

const BASE = '/visual-management/status';

export default {
  async list(params: GPStatusListRequest) {
    const result = (await api.get(`${BASE}`, params)) as unknown;
    return result as GPStatusListResponse;
  },

  async create(data: GPStatusCreateRequest) {
    const result = await api.post(BASE, data);
    return result;
  },

  async detail(statusId?: string) {
    const result = (await api.get(`${BASE}/${statusId}`, null)) as unknown;
    return result as GPStatus;
  },

  async edit({ id, ...data }: GPStatusEditRequest) {
    const result = await api.put(`${BASE}/${id}`, data, null);
    return result;
  },

  async delete(id: string) {
    const result = await api.remove(`${BASE}/${id}`, {}, null);
    return result;
  },

  async position({ id, ...data }: GPStatusPositionEditRequest) {
    const result = await api.patch(`${BASE}/${id}/position`, data, null);
    return result;
  },
};
